import { createMuiTheme } from '@material-ui/core';

export default createMuiTheme({
  overrides: {
    // MuiButton: {
    //   root: {
    //     backgroundColor: 'red',
    //   },
    // },
  },
  palette: {
    background: {
      default: '#f4f6f8',
      paper: '#fff',
    },
  },
});
